import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';



const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#FF6699'];

const FeedbackChartModal = ({ isOpen, onClose, feedbackData11, totalfeedbacksansweredcount }) => {
   
    const [timePeriod, setTimePeriod] = useState('3months');

    if (!isOpen) return null;

    const feedbackEntries = Object.entries(feedbackData11).map(([key, value]) => ({
        name: key,
        value,
    }));

    const totalFeedbacks = feedbackEntries.reduce((acc, entry) => acc + entry.value, 0);

    const renderLabel = ({ name, value }) => {
        const percentage = ((value / totalFeedbacks) * 100).toFixed(1);
        return `${name}: ${percentage}%`;
    };

    const totalFeedbackEntries = Object.entries(totalfeedbacksansweredcount).map(([key, value]) => ({
        name: key === 'Answered Feedback Count' ? 'Answered Count' : 'Unanswered Count', // Updated labels
        value,
    }));

    const totalAnswered = totalFeedbackEntries.reduce((acc, entry) => acc + entry.value, 0);

    const renderTotalLabel = ({ name, value }) => {
        const percentage = ((value / totalAnswered) * 100).toFixed(1);
        return `${name}: ${percentage}%`;
    };


     // Function to filter feedback data based on the selected time period
     const filterFeedbackData = (data) => {
        // Example filtering logic (you will need to replace with actual filtering)
        return data; // Replace this with your filtering logic based on timePeriod
    };

    const filteredFeedbackEntries = filterFeedbackData(feedbackEntries);
    const filteredTotalFeedbackEntries = filterFeedbackData(totalFeedbackEntries);


    return (
        <Dialog 
            open={isOpen} 
            onClose={onClose} 
            fullWidth 
            maxWidth={false} 
            PaperProps={{ style: { height: '100vh', width: '100vw', margin: 0 } }}
        >
           <DialogTitle style={{ margin: 0, padding: '16px 24px', backgroundColor: '#f5f5f5', borderBottom: '1px solid #ddd' }}>
        Feedback Charts
    </DialogTitle>
            <DialogContent style={{ display: 'flex', justifyContent: 'space-between', padding: '20px', height: 'calc(100vh - 64px' }}>
                <div style={{ flex: 1, marginRight: '20px' }}>
                    <Typography variant="h6">Feedback Distribution</Typography>
                    <Typography variant="subtitle1" color="textSecondary">Total Feedbacks: {filteredTotalFeedbackEntries[0].value}</Typography>
                   
                    <FormControl fullWidth>
                            <InputLabel>Time Period</InputLabel>
                            <Select
                                value={timePeriod}
                                onChange={(e) => setTimePeriod(e.target.value)}
                                label="Time Period"
                            >
                                <MenuItem value="3months">Last 3 Months</MenuItem>
                                <MenuItem value="6months">Last 6 Months</MenuItem>
                                <MenuItem value="1year">Last 1 Year</MenuItem>
                            </Select>
                        </FormControl>

                    <PieChart width={700} height={600}>
                        <Pie
                            data={feedbackEntries}
                            dataKey="value"                                                                                             
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            outerRadius={150}
                            fill="#8884d8"
                            label={renderLabel}
                        >
                            {feedbackEntries.map((entry, index) => (
                                <Cell key={index} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip />
                      
                        <Legend layout="vertical" align="center" verticalAlign="bottom" />
                    
                    </PieChart>
                </div>

                <div style={{ flex: 2 }}>
                    <h3>Total Feedbacks Answered Distribution</h3>
                    <PieChart width={900} height={600}>
                        <Pie
                            data={totalFeedbackEntries}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            outerRadius={140}
                            fill="#8884d8"
                            label={renderTotalLabel}
                        >
                            {totalFeedbackEntries.map((entry, index) => (
                                <Cell key={index} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip />
                        <Legend layout="vertical" align="center" verticalAlign="bottom"  />
                    </PieChart>
                </div>
            </DialogContent>
            <DialogActions style={{ margin: 0, padding: '0 24px' }}>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FeedbackChartModal;
